import React, { useEffect, useState } from "react";
import withStyles from "@mui/styles/withStyles";
import { Box, Button, Input, Popover, Typography } from "@mui/material";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

const styles = (theme) => ({
  post: {
    // border: "2px solid " + theme.palette.primary.main,
    borderRadius: "8px",
    padding: theme.spacing(2),
    margin: "1rem auto",
    width: "100%",
    background: theme.palette.primary.main + "16",
  },

  nameBox: {
    color: theme.palette.primary.main,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  postBox: {
    margin: theme.spacing(2, 1),
    display: "flex",
    flexDirection: "column",
    // gap: theme.spacing(2),
  },

  postImg: {
    height: "220px",
    width: "100%",
    aspectRatio: "16/9",
    objectFit: "cover",
    borderRadius: "8px",
  },

  smallText: {
    color: "gray",
    fontSize: "0.75rem",
    fontWeight: 500,
    marginLeft: "10px",
  },

  reactsBox: {
    display: "flex",
    gap: theme.spacing(5),
  },

  popover: {
    display: "flex",
    flexDirection: "column",
    "& span": {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      padding: theme.spacing(1, 2),
      fontWeight: "600",
    },
  },

  replyField: {
    padding: "1rem",
    // border: "2px solid " + theme.palette.primary.main,
    borderRadius: "8px",
    width: "100%",
    margin: theme.spacing(2, 0),
    background: theme.palette.primary.main + "16",
  },

  replyFieldContainer: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    alignItems: "center",
  },

  editField: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },

  replyTextContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
});

const Reply = ({
  classes,
  post,
  currentUser,
  handleDeleteReply,
  goToAuth,
  postReply,
  likePost,
}) => {
  const [popover, setPopover] = useState(false);
  const [openReplies, setOpenReplies] = useState(false);
  const [editing, setEditing] = useState(false);
  const [content, setContent] = useState(post.content);
  const [replyContent, setReplyContent] = useState("");
  const [totalLikes, setTotalLikes] = useState(0);
  const [likedByUser, setLikedByUser] = useState();
  const handlePopover = (e) => {
    setPopover(popover ? false : e.target);
  };

  const handleOpenReplies = () => {
    setOpenReplies(!openReplies);
  };

  const handleGoToEdit = () => {
    setEditing(true);
  };

  const handleSaveEdit = async () => {
    try {
      await axios.put(`/api/socials/replies/update/${post._id}`, { content });
      setEditing(false);
    } catch (error) {
      console.error(error);
    }

    setEditing(false);
    setPopover(false);
  };

  useEffect(() => {
    setTotalLikes(post.likeCount || 0);
    setLikedByUser(post.userHasLiked);
  }, []);

  let date = new Date(post.date);
  let day = String(date.getDate()).padStart(2, "0");
  let month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  let year = date.getFullYear();
  let formattedDate = `${day}/${month}/${year}`;

  return (
    <div className={classes.post}>
      <Box
        sx={{ display: "flex", flexDirection: "column", position: "relative" }}
      >
        <Box className={classes.nameBox}>
          <Typography fontWeight={600}>
            {post.user.first_name + " " + post.user.last_name}
          </Typography>
          {currentUser?.id === post.user._id && !editing && (
            <div>
              <Button disableRipple onClick={(e) => handlePopover(e)}>
                <MoreHorizIcon />
              </Button>
              <Popover
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                anchorEl={popover}
                open={popover}
                onClose={handlePopover}
                disableScrollLock
              >
                <div className={classes.popover}>
                  <span
                    style={{ color: "graytext" }}
                    onClick={() => handleGoToEdit()}
                  >
                    <EditIcon /> Edit
                  </span>
                  <span
                    style={{ color: "red" }}
                    onClick={() => handleDeleteReply(post._id)}
                  >
                    <DeleteIcon /> Delete
                  </span>
                </div>
              </Popover>
            </div>
          )}
        </Box>

        <Box className={classes.postBox}>
          <div>
            <div className={classes.replyTextContainer}>
              {" "}
              {editing ? (
                <div className={classes.editField}>
                  <Input
                    value={content}
                    placeholder="type"
                    autoFocus
                    disableUnderline
                    multiline
                    sx={{ width: "100%" }}
                    onChange={(e) => setContent(e.target.value)}
                  />
                  <Button onClick={() => handleSaveEdit()}>Save</Button>
                </div>
              ) : (
                <div>
                  {post.mentionedUser && (
                    <Typography variant="body" fontWeight={600}>
                      @{post.mentionedUser?.first_name}{" "}
                      {post.mentionedUser?.last_name}{" "}
                    </Typography>
                  )}
                  <span>{content ? content : post.content}</span>
                </div>
              )}
              {!editing && (
                <span
                  className={classes.smallText}
                  style={{ alignSelf: "end" }}
                >
                  {formattedDate}
                </span>
              )}
            </div>
          </div>

          {post.img && <img className={classes.postImg} src="" alt="post" />}
        </Box>

        <Box className={classes.reactsBox}>
          <Typography
            className={classes.smallText}
            sx={{ display: "flex", alignItems: "center", gap: "5px" }}
            onClick={() => handleOpenReplies()}
          >
            <ForumOutlinedIcon sx={{ cursor: "pointer" }} />
            Reply
          </Typography>

          <Typography
            className={classes.smallText}
            sx={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            {likedByUser ? (
              <ThumbUpIcon
                sx={{
                  cursor: "pointer",
                  color: "#9461FF",
                }}
                onClick={() => {
                  setLikedByUser(false);
                  setTotalLikes(totalLikes - 1);
                  likePost("reply", post._id);
                }}
              />
            ) : (
              <ThumbUpOutlinedIcon
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  setLikedByUser(true);
                  setTotalLikes(totalLikes + 1);
                  likePost("reply", post._id);
                }}
              />
            )}
            {totalLikes} Likes
          </Typography>
        </Box>
        {openReplies && (
          <Box className={classes.secondLevelReplies}>
            <div className={classes.replyFieldContainer}>
              <Input
                name="reply"
                className={classes.replyField}
                placeholder={`Replying to ${post.user.first_name} ${post.user.last_name}`}
                disableUnderline
                multiline
                value={replyContent}
                onChange={(e) => setReplyContent(e.target.value)}
              />
              {currentUser ? (
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => postReply(replyContent, post.user._id)}
                >
                  Reply
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => goToAuth()}
                >
                  Login
                </Button>
              )}
            </div>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(Reply);
